__turbopack_context__.v({
  "backdrop": "UlEbSG_backdrop",
  "config": "UlEbSG_config",
  "configContents": "UlEbSG_configContents",
  "content": "UlEbSG_content",
  "content1": "UlEbSG_content1",
  "content2": "UlEbSG_content2",
  "contentOne": "UlEbSG_contentOne",
  "contentTwo": "UlEbSG_contentTwo",
  "desktopBr": "UlEbSG_desktopBr",
  "imgContainer": "UlEbSG_imgContainer",
  "root": "UlEbSG_root",
});
